export default {"src":"/_next/static/media/DWAC.c4fc2e12.svg","height":18,"width":18};